<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary ml-1">EUROED</h2>
    </a>
    <!-- /Brand logo-->
    <!-- Left Text-->
    <div class="d-none d-lg-flex col-lg-8 align-items-center" style="padding: 0 !important; margin: 0 !important;">
      <video autoplay muted [muted]="'muted'" loop controls id="myVideo">
        <source src="assets\video\EUROED Promotional Video 2019 - Portuguese Version.mp4" type="video/mp4">
      </video>
    </div>
    <!-- /Left Text-->
    <!-- Forgot password-->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">Esqueceu-se da senha? 🔒</h2>
          <p class="card-text mb-2">Indique o seu email para recuperar a senha.</p>
          <form class="auth-forgot-password-form mt-2" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label class="form-label" for="forgot-password-email">Email</label>
              <input class="form-control" type="text" formControlName="email" placeholder="oseu@example.com"
                aria-describedby="forgot-password-email" autofocus="" tabindex="1"
                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email é obrigatório</div>
                <div *ngIf="f.email.errors.email">Email deve ser válido</div>
              </div>
            </div>
            <button class="btn btn-primary btn-block" tabindex="2" rippleEffect>Recuperar Senha</button>
          </form>
        <ng-container *ngIf="success">
          <br>
          <ngb-alert [type]="'success'" [dismissible]="false">
            <div class="alert-body">Enviado! Consulte o seu email.</div>
          </ngb-alert>
        </ng-container>
        <p class="text-center mt-2">
          <a routerLink="/pages/authentication/login-v2"><i data-feather="chevron-left" class="mb-25"></i> Voltar ao
            login</a>
        </p>
      </div>
    </div>
    <!-- /Forgot password-->
  </div>
</div>